<template>
    <tabs parent="traffic_packet_list" v-if="show_page">
        <tab
            id="device_packet_items"
            :name="translate('traffic_packet_list.tariff_packet_item.title')"
            :href="url+'device_packet_items?status=1'"
            v-if="$store.getters.getPermissions.viewCommerceData === true && this.$store.getters.getPermissions.permissionGod === true"
        >
            <DevicePacketItems />
        </tab>

        <tab
            id="tariffication_packet_items"
            :name="translate('traffic_packet_list.tariffication_packet_item.title')"
            :href="url+'tariffication_packet_items'"

            v-if="$store.getters.getPermissions.viewCommerceData === true && this.$store.getters.getPermissions.permissionGod === true"
        >
            <TarifficationPacketItems />
        </tab>

        <tab
            id="mno_packet_items"
            :name="translate('traffic_packet_list.mno_packet_item.title')"
            :href="url+'mno_packet_items'"
            v-if="this.$store.getters.getPermissions.viewCommerceData === true && this.$store.getters.getPermissions.permissionGod === true"
        >
            <MnoPacketItems />
        </tab>

        <tab id="mno_base_packets"
             :name="translate('traffic_packet_list.mno_base_packet.title')"
             :href="url+'mno_base_packets'"
             v-if="$store.getters.getPermissions.viewCommerceData === true && this.$store.getters.getPermissions.permissionGod === true"
        >
            <MnoBasePackets />
        </tab>

        <tab
            id="tariff_base_packets"
            :name="translate('traffic_packet_list.tariff_base_packet.title')"
            :href="url+'tariff_base_packets'"
            v-if="$store.getters.getPermissions.viewCommerceData === true && this.$store.getters.getPermissions.permissionGod === true"
        >
            <TariffBasePackets />
        </tab>
    </tabs>

    <div v-else style="height: 100%" >
        <div class="spinner">
            <scale-loader />
        </div>
    </div>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import DevicePacketItems from './Tabs/DevicePacketItems/Index.vue'
import TarifficationPacketItems from './Tabs/TarifficationPacketItems/Index.vue'
import MnoPacketItems from './Tabs/MnoPacketItems/Index.vue'
import MnoBasePackets from "./Tabs/MnoBasePackets/Index.vue";
import TariffBasePackets from "./Tabs/TariffBasePackets/Index.vue";

export default {
    name: 'TrafficPacketList',
    components:{
      TariffBasePackets,
      Tab,
      Tabs,
      DevicePacketItems,
      MnoPacketItems,
      TarifficationPacketItems,
      MnoBasePackets,
    },
    props: {
    },
    data () {
      return {
          tariff_list: {},
          show_page: false,
          tariff_filter: {}
      }
    },
    computed: {
        url () { return '/traffic_packet_list/' },
    },

    created () {
        this.get_tariff_list()
    },

    methods: {
        get_tariff_list(){
            this.$http.v1.getTariffList({}, (response) => {
                this.tariff_list = response.data
                this.show_page = true
            })
        },
    },
}
</script>
